<template>
    <path :style="{ fill: color }" d="M35.1,52.1c-0.1,0-0.8-2.9-1.1-4.2c-0.3-1.2,0.2-2-0.3-2.9c-0.5-0.8-1.9-1.5-2.1-4.1
	c-0.2-2.7,0.7-2.6,0.3-5.6c-0.4-3-1.6-3.2-1.6-5.5c0-2,1.7-3,1.7-3.6c-0.1-1.2-1.5-3.5,0.1-5.7c1.5-2.2,2.5-3.5,3.9-3.9
	c1.4-0.4,2.6-2.5,3.6-4.4c1-1.9,3.7-3.2,6-2.5c2.3,0.8,6-4,10.4-3c4.5,1,4.4,2.5,6.8,2.1c2.4-0.4,4.5-0.1,7.2,2.4
	c2.2,2,2.1,4.3,3.6,5.8c0.6,0.6,2.6,1.4,3.7,3.6c1.1,2.2-0.2,4.8,0.6,6.5c1.3,2.9,1.1,6.4,0.4,7.9c-0.7,1.5-2,3.1-1.7,5.3
	c0.3,2.2-0.7,4.1-1.1,5.2c-0.3,1.1-1.7,6.3-2,6.3c-0.2,0,0.3-3.3,0.3-7.2c0.1-3.9-0.9-4.1-0.9-8.7c0-4.5-0.6-7.4-3.6-8.5
	c-2.9-1.1-5.7,2.8-10.7,2.4c-5-0.4-6.9-3.4-10.7-2.4c-3.8,1-7.8-1.8-9.9,1.3c-2.1,3.1-1,6.3-1.5,9.5c-0.5,3.2-1.1,3.6-1.2,5.3
	C35.2,46.9,35.3,52.1,35.1,52.1z"/>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair5',
        mixins: [Hair],
    }
</script>

